import WithRender from "../../templates/ui/tooltip.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getTooltipContent", "getIsTooltipsActive"]),
    getContent: function () {
      return this.getTooltipContent(this.tooltip);
    },
    getIsMobile: function () {
      return window.innerWidth <= 990;
    }
  },
  methods: {
    getTriggerEvent: function (tooltip) {
      return {
        content: tooltip,
        trigger: this.getIsMobile ? "click" : "hover",
        autoHide: false
      };
    }
  },
  props: ["tooltip"]
});
